<script>
	import PageSection from "../../components/PageSection.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";

	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";

	export let pageTitle = `${projectSettings.classActionName} - Information Submitted`;

	document.title = pageTitle;

	window.onbeforeunload = null;
</script>

<PageSection>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		</FormColumn>
	</FormRow>

	<FormRow>
		<FormColumn>
			<p>
				Hi {window.name}
			</p>
			<p>
				You have previously submitted the Return Registration Form, you are unable to complete this form again.
				If you need to amend any of the details provided, please contact Shine Lawyers on <ClassActionPhoneNumber />
				or via email to <ClassActionEmailAddress />.
			</p>
			<br />
			<p>Yours sincerely,</p>
			<p>Shine Lawyers</p>
		</FormColumn>
	</FormRow>
</PageSection>

<style>
</style>
